// Gate for the Salesforce (SF) upload on broadcast autopodder jobs.
//
// The broadcast autopodder writes each strategy's summary and its SF upload csv
// into job_result_json as the strategy finishes, while the job stays RUNNING.
// The first two strategies are quick, so the upload is offered once both have
// landed instead of waiting for the slow tail of the run.

export const MIN_STRATEGIES_FOR_SF_UPLOAD = 2;

// Number of strategies with a result in job_result_json. Broadcast jobs keep
// them under `data`, syndication jobs under `strategies`. A placeholder such as
// "{}" or malformed JSON counts as no results.
export function countStrategiesInJobResult(jobResultJson: string | null | undefined): number {
  if (!jobResultJson) return 0;
  try {
    const parsed = JSON.parse(jobResultJson);
    const strategiesObj = parsed?.data || parsed?.strategies;
    if (strategiesObj && typeof strategiesObj === 'object') {
      return Object.keys(strategiesObj).length;
    }
  } catch (e) {
    // malformed/placeholder JSON → treat as no results yet
  }
  return 0;
}

export function isSfUploadAvailable(jobStatus: string | undefined, strategyCount: number): boolean {
  if (jobStatus === 'FINISHED') return true;
  return strategyCount >= MIN_STRATEGIES_FOR_SF_UPLOAD;
}
